import { theme } from '@faxi/web-component-library';
import { laptop, mobile } from '@faxi/web-css-utilities';
import styled, { css } from 'styled-components';

import { LayoutSection } from '../../layouts';

const StyledBenefitsSection = styled(LayoutSection)`
  .cedolauto-benefits-section {
    &__cards {
      width: fit-content;
      margin: auto;
      display: grid;
      gap: ${theme.sizes.SIZE_40};
      grid-template-columns: repeat(3, 1fr);

      ${laptop(css`
        grid-template-columns: repeat(2, 1fr);
      `)}

      ${mobile(css`
        grid-template-columns: 1fr;
      `)}
    }
  }
`;

export { StyledBenefitsSection };
